/* eslint-disable */
import changeCase from 'change-object-case';
import { connect } from 'react-redux'
import React, { Component } from 'react';
import { Button, Form, InputGroup, FormGroup, FormControl, Radio, ControlLabel, HelpBlock, Checkbox, Alert } from 'react-bootstrap';
import { ss, url, authJsonHeader, mapDispatch } from '../../utils/util';

import OzFormComponent from './OzFormComponent';
import './LoginForm.css';

import { forgotPassword } from '../../actions';


class LoginForm extends OzFormComponent {

  static fields = [
    'username',
    'password',
    'forgot',
  ]

  renderBody() {
    if (this.state.showForgot) {
      return (
        <div className="LoginForm">
          {this.renderFormGroup('Email or username', 'text', 'forgot')}
        </div>
      )
    }

    return (
      <div className="LoginForm">
        {this.renderErrors('nonFieldErrors')}
        {this.renderFormGroup('Username', 'text', 'username')}
        {this.renderFormGroup('Password', 'password', 'password')}

        <div className="forgot" onClick={() => this.setState({ showForgot: true, buttonText: 'Send Reset Link' })}>Forgot username/password?</div>
      </div>
    );
  }
}


function mapStateToProps(state) {
  return {
    errors: state.errors.login,
  };
}

function mapDispatchToProps(dispatch) {
  return mapDispatch(dispatch, {
    forgotPassword,
  });
}

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(LoginForm);



/** WEBPACK FOOTER **
 ** ./src/components/partials/LoginForm.js
 **/